import { type TextProps } from '@mantine/core'

import { type CoreProduct } from '@flecto/types'
import { TextCurrency } from '@flecto/ui'

import { useBundlePrice } from './useBundlePrice'

export type TextBundlePriceProps = TextProps & { bundle: CoreProduct }

export function TextBundlePrice({ bundle, ...props }: TextBundlePriceProps) {
  const price = useBundlePrice(bundle)

  return <TextCurrency cents={price} {...props} />
}
